// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChannelViewer_wrapper__3y3gm","hidden":"ChannelViewer_hidden__1_kuk"};